(function () {
    'use strict';

    angular.module("imApp").factory("freightRateService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1548,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1549,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
